var render = function render(){var _vm=this,_c=_vm._self._c;return _c('symbol',{attrs:{"id":`${_vm.prefix}switch`,"viewBox":"0 0 25 16"}},[_c('rect',{attrs:{"fill":_vm.getColor(_vm.choiceState),"width":"25","height":"16","rx":"8","ry":"8"}}),_c('circle',{staticClass:"switcher",class:[_vm.choiceState],attrs:{"fill":_vm.getColor('switcher'),"cx":"8","cy":"8","r":"6"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }